
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clientapp/auth/signup",
      function () {
        return require("private-next-pages/clientapp/auth/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clientapp/auth/signup"])
      });
    }
  